/**
 * Datapoints to capture Load calendar action times
 */
export default {
    LoadCalendarModuleE2E: {
        name: 'LoadCalendarModuleE2E',
        options: {
            logVerbose: true /* capture waterfall always*/,
            isCore: true,
        },
    },
};
